"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const expect_1 = __importDefault(require("./util/expect"));
const configuration = {
    database: undefined,
    firestore: undefined,
    getDatabase() {
        return (0, expect_1.default)(this.database, 'realtime database data source');
    },
    getFirestore() {
        return (0, expect_1.default)(this.firestore, 'firestore data source');
    },
};
exports.default = configuration;
